import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { Action, Filter, paginatedFetchGroups, selectGroups } from '~/ProductGroup';
import { State, ThunkAction } from '~/Store';

import FolderSelect from './FolderSelect';

const memoizedSelectGroups = memoizeOne((state, filter) => {
	const groupsState = selectGroups(state.productGroup, filter);
	return {
		...groupsState,
		groups: groupsState.groups.filter((group) => group.isGroup()),
	};
});

const selectFilter = memoizeOne((nameFilter) => {
	return new Filter(null, Array.from(nameFilter).length >= 3 ? nameFilter : null);
});

function mapStateToProps(state: State, { nameFilter }: { nameFilter: string }) {
	const groupsState = memoizedSelectGroups(state, selectFilter(nameFilter));

	return {
		isFetching: state.accessToken.isFetching || groupsState.status === 'fetching',
		groups: groupsState.groups,
		hasMore: groupsState.pagination?.hasNextPage() ?? false,
	};
}

const actions = {
	onFetch:
		(nameFilter: string): ThunkAction<Promise<void>, Action> =>
		(dispatch) =>
			dispatch(paginatedFetchGroups(selectFilter(nameFilter))),
};

export default connect(mapStateToProps, actions)(FolderSelect);
